import { render, staticRenderFns } from "./courseChapter.vue?vue&type=template&id=533ecae0&scoped=true&"
import script from "./courseChapter.vue?vue&type=script&lang=js&"
export * from "./courseChapter.vue?vue&type=script&lang=js&"
import style0 from "./courseChapter.vue?vue&type=style&index=0&id=533ecae0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ecae0",
  null
  
)

export default component.exports